module.exports = __webpack_public_path__ + "static/media/background-default.397d27f9.jpg";